export const COUNTRY_INDICATORS = [
  { country: 'Colombia', indicator: '+57', flag: '🇨🇴' },
  { country: 'United States', indicator: '+1', flag: '🇺🇸' },
  { country: 'Canada', indicator: '+1', flag: '🇨🇦' },
  { country: 'Mexico', indicator: '+52', flag: '🇲🇽' },
  { country: 'Brazil', indicator: '+55', flag: '🇧🇷' },
  { country: 'Argentina', indicator: '+54', flag: '🇦🇷' },
  { country: 'Germany', indicator: '+49', flag: '🇩🇪' },
  { country: 'France', indicator: '+33', flag: '🇫🇷' },
  { country: 'United Kingdom', indicator: '+44', flag: '🇬🇧' },
  { country: 'Spain', indicator: '+34', flag: '🇪🇸' },
  { country: 'Italy', indicator: '+39', flag: '🇮🇹' },
  { country: 'Australia', indicator: '+61', flag: '🇦🇺' },
  { country: 'China', indicator: '+86', flag: '🇨🇳' },
  { country: 'India', indicator: '+91', flag: '🇮🇳' },
  { country: 'Japan', indicator: '+81', flag: '🇯🇵' },
  { country: 'South Korea', indicator: '+82', flag: '🇰🇷' },
  { country: 'Russia', indicator: '+7', flag: '🇷🇺' },
  { country: 'South Africa', indicator: '+27', flag: '🇿🇦' },
  { country: 'Saudi Arabia', indicator: '+966', flag: '🇸🇦' },
  { country: 'United Arab Emirates', indicator: '+971', flag: '🇦🇪' },
  { country: 'Netherlands', indicator: '+31', flag: '🇳🇱' },
  { country: 'Sweden', indicator: '+46', flag: '🇸🇪' },
  { country: 'Switzerland', indicator: '+41', flag: '🇨🇭' },
  { country: 'Norway', indicator: '+47', flag: '🇳🇴' },
  { country: 'Denmark', indicator: '+45', flag: '🇩🇰' },
  { country: 'Finland', indicator: '+358', flag: '🇫🇮' },
  { country: 'Greece', indicator: '+30', flag: '🇬🇷' },
  { country: 'Turkey', indicator: '+90', flag: '🇹🇷' },
  { country: 'Egypt', indicator: '+20', flag: '🇪🇬' },
];
